import React, {Component} from 'react';
import './CSVFileFormatDetails.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Button} from 'reactstrap';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

const BULK_FILE_EXAMPLE = [
    "email,firstName,lastName,countryCode,nationalId,issuedAt,level,original,en,fr,nl\n",
    "june.rogers@email.com,June,Rogers,CA,836154446309,2017-05-01,MASTER,Original title,English title,Titre français,Nederlandse titel\n",
    "dean.arnold@email.com,Dean,Arnold,US,289298416441,2017-09-15,POST_GRADUATE,Original title,English title,,Nederlandse titel\n",
    "terry.mullins@email.com,Terry,Mullins,GB,273822698758,2012-12-12,TECHNICAL,Original title,English title,Titre français,Nederlandse titel\n",
    "velma.walsh@email.com,Velma,Walsh,FR,627573870715,2007-06-25,PHD,Original title,English title,Titre français,Nederlandse titel\n",
    "kelly.larson@email.com,Kelly,Larson,DE,622358932838,2004-03-07,BACHELOR,Original title,English title,Titre français,Nederlandse titel"
];

const VALUES_DETAILS = [
    {
        name: "email",
        isRequired: "no_label",
        mean: "email_mean_label",
        format: "email_format",
    },
    {
        name: "firstName",
        isRequired: "yes_label",
        mean: "first_name_mean_label",
        format: "string_format",
    },
    {
        name: "lastName",
        isRequired: "yes_label",
        mean: "last_name_mean_label",
        format: "string_format",
    },
    {
        name: "countryCode",
        isRequired: "yes_label",
        mean: "country_code_mean_label",
        format: "country_code_format",
    },
    {
        name: "nationalId",
        isRequired: "yes_label",
        mean: "national_id_mean_label",
        format: "string_format",
    },
    {
        name: "issuedAt",
        isRequired: "yes_label",
        mean: "date_issued_mean_label",
        format: "date_format",
    },
    {
        name: "level",
        isRequired: "yes_label",
        mean: "level_mean_label",
        format: "level_format",
    },
    {
        name: "original",
        isRequired: "yes_label",
        mean: "original_mean_label",
        format: "string_format",
    },
    {
        name: "en",
        isRequired: "yes_label",
        mean: "en_mean_label",
        format: "string_format",
    },
    {
        name: "lang_code",
        isRequired: "no_label",
        mean: "lang_code_mean_label",
        format: "string_format",
    }
];

class CSVFileFormatDetails extends Component {
    render() {
        return (
            <div className='bulk-csv-file-format-details-container'>
                <div
                    className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.use_csv_message')}</div>

                <h5 className="text-center">{_.get(this.props.translation, 'bulk_file_format_details.csv_file_example_label')}</h5>
                <div className="bulk-csv-file-example">
                    {this.getFileExampleText()}
                </div>
                <div className="bulk-csv-example-download-container">
                    <Button
                        onClick={this.downloadCSVFile}>{_.get(this.props.translation, 'bulk_file_format_details.download_example_button')}</Button>
                </div>

                <div
                    className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.file_header_message')}</div>
                <div className='bulk-csv-file-format-info bulk-header-list'><span
                    className='optional-field'>{"email"}</span>{",firstName,lastName,countryCode,nationalId,issuedAt,level,original,en"}<span
                    className='optional-field'>,{_.get(this.props.translation, 'bulk_file_format_details.additional_titles_label')}</span>.
                </div>
                <div className='bulk-csv-file-format-info'>
                    ({_.get(this.props.translation, 'bulk_file_format_details.optional-fields-highlighted-label') + ' '}<span
                    className={'optional-field'}>{_.get(this.props.translation, 'bulk_file_format_details.gray_label')}</span>.)
                </div>
                <div
                    className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.provide_data_message')}</div>
                <ul className='bulk-csv-file-format-requirements-list'>
                    <li className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.applicant_data_message')}</li>
                    <li className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.accreditation_data_message')}</li>
                </ul>
                <div
                    className='bulk-csv-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.file_entries_message')}</div>

                <h5 className="text-center bulk-csv-file-format-values-detail-header">{_.get(this.props.translation, 'bulk_file_format_details.values_details_label')}</h5>
                <div
                    className='bulk-csv-file-format-info'>{"*" + _.get(this.props.translation, 'bulk_file_format_details.email_details')}</div>
                <div
                    className='bulk-csv-file-format-info'>{"**" + _.get(this.props.translation, 'bulk_file_format_details.date_issued_details')}</div>
                {this.renderValueDetailsTable()}
            </div>
        );
    }

    renderValueDetailsTable = () => {
        return (
            <Table className="bulk-csv-values-details-table" bordered>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.header_name_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.required_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.mean_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.format_label')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderValuesDetailsData()}
                </tbody>
            </Table>
        )
    };

    renderValuesDetailsData = () => {
        return _.map(VALUES_DETAILS, (elem, id) => (
            <tr key={id}>
                <td className="header-codes-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.header_name_label') + ":"}>
                    {elem.name === "lang_code" ? "[" + _.get(this.props.translation, 'bulk_file_format_details.language_code_label') + "]" : elem.name}
                </td>
                <td className="required-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.required_label') + ":"}>
                    {_.get(this.props.translation, sharedLabelsPath[elem.isRequired]) + (elem.name === "email" ? " (*)" : "")}
                </td>
                <td className="mean-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.mean_label') + ":"}>
                    {_.get(this.props.translation, "bulk_file_format_details." + elem.mean)}
                </td>
                <td className="format-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.format_label') + ":"}>
                    {_.get(this.props.translation, "bulk_file_format_details." + elem.format)}
                </td>
            </tr>
        ));
    };

    getFileExampleText = () => {
        let result = [];
        BULK_FILE_EXAMPLE.forEach((row, id) => {
            result.push(row);
            result.push(<br key={id}/>);
        });
        return result;
    };

    downloadCSVFile = () => {
        let element = document.createElement("a");
        let file = new Blob(BULK_FILE_EXAMPLE, {type: 'text/csv'});
        element.href = URL.createObjectURL(file);
        element.download = "bulk_csv_file_example.csv";
        element.click();
    }
}

CSVFileFormatDetails.propTypes = {
    translation: PropTypes.object.isRequired
};

export default CSVFileFormatDetails;



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkFileFormatDetails/CSVFileFormatDetails/CSVFileFormatDetails.js